import React from 'react';
import HeroSlider from '../components/HeroSlider';
import Rooms from '../components/Rooms';
import YChoose from '../components/YChoose';
import Questions from '../components/Questions';
import CustomerFeedback from '../components/CustomerFeedback';

const Home = () => {
  return (
    <>
      <HeroSlider />
      <Rooms />
      <YChoose />
      <Questions />
      <CustomerFeedback layout="row" limit={12} />
    </>
  );
};

export default Home;
